/**
 * Thanh tuu (25) + suu tap theo nhom hang (M3).
 *
 * Thuong xu cao cap - nguon xu cao cap khi chua bat IAP (master-plan 2.4),
 * cung voi don lon. Kiem tra moi tick; mo la thuong ngay + tra ve danh sach
 * vua mo (UI hien toast).
 *
 * (Chu thich viet khong dau o day de tranh loi encoding khi ghi file;
 *  JSDoc tieng Viet co dau nam o cac module khac.)
 */
import { khuDaMo } from './khu-vuc.js';
import type { DuLieuGame, LoaiDieuKienThanhTuu, ThanhTuu, TrangThaiGame } from './types.js';

/** Gia tri hien tai cua mot loai dieu kien thanh tuu. */
export function giaTriDieuKien(
  state: TrangThaiGame,
  duLieu: DuLieuGame,
  loai: LoaiDieuKienThanhTuu,
): number {
  switch (loai) {
    case 'tongMonBan':
      return state.thongKe.tongMonDaBan;
    case 'tongLaiGop':
      return state.thongKe.tongLaiGop;
    case 'capCuaHang':
      return state.capCuaHang;
    case 'capNguoiChoi':
      return state.nguoiChoi.cap;
    case 'nvHoanThanh':
      return state.thongKe.soNvHoanThanh;
    case 'donLonHoanThanh':
      return state.thongKe.soDonLonHoanThanh;
    case 'npcThanThiet5':
      return Object.values(state.npcThanThiet).filter((c) => c >= 5).length;
    case 'caPheDaBan':
      return state.thongKe.tongCocCaPhe;
    case 'ngayGame':
      return Math.floor(state.tongGioGame / 24);
    case 'thueNhanVien':
      return (state.nhanVien.thuNgan ? 1 : 0) + (state.nhanVien.xepKe ? 1 : 0);
    case 'khuDaMo':
      return khuDaMo(state, duLieu).length;
    default:
      return 0;
  }
}

/**
 * Kiem tra va mo thanh tuu moi. Tra ve danh sach vua mo (de UI thong bao).
 * Goi 1 lan moi tick - re (25 dieu kien).
 */
export function kiemTraThanhTuu(state: TrangThaiGame, duLieu: DuLieuGame): ThanhTuu[] {
  const vuaMo: ThanhTuu[] = [];
  for (const tt of duLieu.thanhTuu.thanhTuu) {
    if (state.thanhTuuDaMo.includes(tt.ma)) continue;
    if (giaTriDieuKien(state, duLieu, tt.loaiDieuKien) >= tt.nguong) {
      state.thanhTuuDaMo.push(tt.ma);
      state.xuCaoCap += tt.thuongXuCaoCap;
      vuaMo.push(tt);
    }
  }
  return vuaMo;
}

/** Nhom hang da hoan thanh suu tap (da tung ban moi mon trong nhom). */
export function nhomSuuTapXong(state: TrangThaiGame, duLieu: DuLieuGame, nhom: string): boolean {
  const cacMon = duLieu.matHang.filter((m) => m.nhom === nhom);
  if (cacMon.length === 0) return false;
  return cacMon.every((m) => (state.thongKe.monDaBan[m.ma] ?? 0) > 0);
}

/**
 * Kiem tra suu tap moi hoan thanh. Tra ve ten nhom vua xong.
 */
export function kiemTraSuuTap(state: TrangThaiGame, duLieu: DuLieuGame): string[] {
  const vuaXong: string[] = [];
  const daXong = new Set(state.suuTapXong);
  for (const st of duLieu.suuTap.suuTap) {
    if (daXong.has(st.nhom)) continue;
    if (nhomSuuTapXong(state, duLieu, st.nhom)) {
      state.suuTapXong.push(st.nhom);
      state.xuCaoCap += st.thuongXuCaoCap;
      vuaXong.push(st.nhom);
    }
  }
  return vuaXong;
}
